import { Trans } from 'react-i18next'
import CouponIcon from '@mui/icons-material/LocalOfferOutlined'

import { useDefaultPromoCode, usePromoCodeDescription } from '../../../../modules/promoCodes'
import { usePlatformName } from '../../../../modules/appConfig'

const Coupon: React.FC = () => {
  const { promoCode, fromPlatform } = useDefaultPromoCode()
  const description = usePromoCodeDescription(promoCode)
  const platformName = usePlatformName()

  const discountFromPlatform = fromPlatform && platformName

  if (!description) {
    return null
  }

  const CouponDescription = () => (<strong>{ description }</strong>)
  const PlatformName = () => (<strong>{ platformName }</strong>)

  return (
    <div className="m-4 text-center font-body text-lg text-green-700 md:px-0">
      <CouponIcon />
      { ' ' }

      { discountFromPlatform
        ? (
          <Trans i18nKey="forms.quotesRequest.coupon.couponWillBeAppliedFromPlatform">
            <PlatformName />
            <CouponDescription />
          </Trans>
          )
        : (
          <Trans i18nKey="forms.quotesRequest.coupon.couponWillBeApplied">
            <CouponDescription />
          </Trans>
          ) }

    </div>
  )
}

export default Coupon
